var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164.1 164.1",
    style: {
      enableBackground: "new 0 0 164.1 164.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#203162;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M82.1,164.5C36.8,164.5,0,127.7,0,82.4S36.8,0.3,82.1,0.3s82.1,36.8,82.1,82.1 S127.3,164.5,82.1,164.5z M82.1,4.3C39,4.3,4,39.4,4,82.4c0,43,35,78.1,78.1,78.1c43,0,78.1-35,78.1-78.1 C160.1,39.4,125.1,4.3,82.1,4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st0",
    d: "M71.5,70.2c5.1,0,9.6,0,14.4,0c0.2,1.8,0.4,3.5,0.6,5.5c2.1-1.7,3.7-3.3,5.5-4.4 c12-7.5,27-0.1,27.6,13.9c0.4,9.1,0.1,18.3,0.1,27.5c0,2.2,0,4.4,0,7c-5.1,0-9.9,0-15.4,0c0-9.5,0.2-18.8-0.1-28.1 c-0.2-7-4.1-10-10.5-8.7c-4.4,0.9-6.3,4.2-6.4,8.2c-0.3,7.2-0.3,14.3-0.4,21.5c0,2.3,0,4.7,0,7.3c-5.4,0-10.1,0-15.3,0 C71.5,103.5,71.5,87.1,71.5,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st0",
    d: "M46,70.3c5.1,0,9.8,0,14.9,0c0,16.5,0,32.7,0,49.4c-4.7,0-9.6,0-14.9,0 C46,103.5,46,87.1,46,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st0",
    d: "M62.5,53.8c0.1,5-3.9,9.1-8.8,9.2c-5,0.1-9.1-3.9-9.3-8.9c-0.1-4.9,4-9.2,8.9-9.3 C58.2,44.8,62.4,48.8,62.5,53.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInF);
export default __webpack_public_path__ + "static/media/in_f.453ed59bd1cefd6fb864218229cf9dcc.svg";
export { ForwardRef as ReactComponent };